import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/NavBar';

export default function Support() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      <NavBar />

      <div className="max-w-4xl mx-auto px-4 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">
            Centre d'Aide - Pulse
          </h1>
          <p className="text-xl text-gray-300">
            Nous sommes là pour vous aider
          </p>
        </div>

        {/* Contact Section */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 mb-8 border border-white/20">
          <h2 className="text-2xl font-bold text-white mb-4">
            Contactez-nous
          </h2>
          <div className="space-y-4">
            <div>
              <p className="text-gray-300 mb-2">
                Pour toute question, suggestion ou problème technique :
              </p>
              <a
                href="mailto:29beaugarcon@gmail.com"
                className="text-blue-400 hover:text-blue-300 text-lg font-semibold"
              >
                emilerobitaille2004@gmail.com
              </a>
            </div>
            <p className="text-gray-400 text-sm">
              Nous nous efforçons de répondre à toutes les demandes dans les 24-48 heures.
            </p>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 mb-8 border border-white/20">
          <h2 className="text-2xl font-bold text-white mb-6">
            Questions Fréquentes (FAQ)
          </h2>

          <div className="space-y-6">
            {/* Question 1 */}
            <div>
              <h3 className="text-lg font-semibold text-white mb-2">
                Comment rejoindre un club de course ?
              </h3>
              <p className="text-gray-300">
                Depuis la page d'accueil, parcourez la liste des clubs disponibles ou utilisez la carte
                pour trouver des clubs près de chez vous. Cliquez sur "Rejoindre" pour devenir membre
                d'un club public, ou attendez l'approbation pour un club privé.
              </p>
            </div>

            {/* Question 2 */}
            <div>
              <h3 className="text-lg font-semibold text-white mb-2">
                Comment connecter mon compte Strava ?
              </h3>
              <p className="text-gray-300">
                Allez dans votre profil et cliquez sur "Connecter à Strava". Vous serez redirigé vers
                Strava pour autoriser la connexion. Vos activités de course seront automatiquement
                synchronisées.
              </p>
            </div>

            {/* Question 3 */}
            <div>
              <h3 className="text-lg font-semibold text-white mb-2">
                Qu'est-ce que les Daily Photos ?
              </h3>
              <p className="text-gray-300">
                Les Daily Photos vous permettent de partager vos photos de course quotidiennes avec
                votre club. Pour débloquer cette fonctionnalité, vous devez avoir couru ce jour-là
                (activité Strava détectée).
              </p>
            </div>

            {/* Question 4 */}
            <div>
              <h3 className="text-lg font-semibold text-white mb-2">
                Comment créer mon propre club ?
              </h3>
              <p className="text-gray-300">
                Connectez-vous à votre compte, cliquez sur "Créer un club" dans le menu. Remplissez
                les informations du club (nom, description, ville, niveau) et choisissez si votre club
                est public ou privé.
              </p>
            </div>

            {/* Question 5 */}
            <div>
              <h3 className="text-lg font-semibold text-white mb-2">
                Comment supprimer mon compte ?
              </h3>
              <p className="text-gray-300">
                Pour supprimer votre compte, envoyez-nous un email à{' '}
                <a href="mailto:29beaugarcon@gmail.com" className="text-blue-400 hover:text-blue-300">
                  29beaugarcon@gmail.com
                </a>{' '}
                avec l'objet "Suppression de compte". Nous traiterons votre demande dans les plus brefs délais.
              </p>
            </div>

            {/* Question 6 */}
            <div>
              <h3 className="text-lg font-semibold text-white mb-2">
                L'application est-elle gratuite ?
              </h3>
              <p className="text-gray-300">
                Oui, Pulse est entièrement gratuite. Aucun achat intégré ni abonnement n'est requis.
              </p>
            </div>
          </div>
        </div>

        {/* About Section */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 mb-8 border border-white/20">
          <h2 className="text-2xl font-bold text-white mb-4">
            À propos de Pulse
          </h2>
          <p className="text-gray-300 mb-4">
            Pulse est une application mobile qui connecte les coureurs passionnés à travers des clubs
            de course locaux. Notre mission est de créer une communauté active et engagée où chacun
            peut partager sa passion pour la course à pied.
          </p>
          <p className="text-gray-300">
            Développée avec passion pour les coureurs, par des coureurs.
          </p>
        </div>

        {/* Feedback Section */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20">
          <h2 className="text-2xl font-bold text-white mb-4">
            Votre avis compte
          </h2>
          <p className="text-gray-300 mb-4">
            Nous sommes constamment en train d'améliorer Pulse. Si vous avez des suggestions,
            des idées de nouvelles fonctionnalités ou si vous rencontrez un problème,
            n'hésitez pas à nous contacter.
          </p>
          <a
            href="mailto:emilerobitaille2004@gmail.com?subject=Feedback Pulse"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            Envoyer un feedback
          </a>
        </div>

        {/* Back to Home */}
        <div className="text-center mt-12">
          <Link
            to="/"
            className="text-blue-400 hover:text-blue-300 font-semibold"
          >
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
